import { render, staticRenderFns } from "./TestScreeningUnAdd.vue?vue&type=template&id=1e4150b9&scoped=true&"
import script from "./TestScreeningUnAdd.vue?vue&type=script&lang=js&"
export * from "./TestScreeningUnAdd.vue?vue&type=script&lang=js&"
import style0 from "./TestScreeningUnAdd.vue?vue&type=style&index=0&id=1e4150b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4150b9",
  null
  
)

export default component.exports